import { join as intercalate } from 'ramda'

// export default unwords

/**
 * (Iterable | Foldable) String -> String
 * @param values (Iterable | Foldable) String
 * @return String
 */
const unwords = intercalate (' ')

export default unwords
